import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-545f4f3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-login-container" }
const _hoisted_2 = { class: "account" }
const _hoisted_3 = {
  key: 0,
  class: "account-container"
}
const _hoisted_4 = { class: "account-content tenant-search-content" }
const _hoisted_5 = { class: "account-row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "account-content" }

import { ref, computed, onUnmounted } from 'vue'
import { LoginToken } from '@/mobile/src/types/auth'
import {
    buildMagicLink,
    loginSupportAndRedirectHome,
} from '@/mobile/src/services/auth'
import store from '@/mobile/src/store'
import router from '@/mobile/src/router'
import BackHeader from '@/mobile/src/components/appV4/headers/BackHeader.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'
import InputSingleLine from '@/components/Rain/Inputs/InputSingleLine.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import {
    faArrowCircleRight,
    faHourglassHalf,
} from 'fontawesome/free-solid-svg-icons'
import { ToastColor, ToastIcon } from '@/mobile/src/types/toasts'
import { hideToast, showToast } from '@/mobile/src/utils/toastbus'
import useEmitter from '@/composables/useEmitter'

interface LoginTokenFull extends LoginToken {
    domain: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseLogin',
  emits: ['choose-account'],
  setup(__props, { emit: __emit }) {

const emitter = useEmitter()
const emit = __emit
const loginTokens = computed(() => store.getters['loginTokens'])
const adminToken = computed(() => store.getters['adminToken'])
const adminEmail = computed(() => store.getters['email'])

const tenant = ref('')
const error = ref('')
const loading = ref(false)

// convert (domain) keyed object to array
const loginTokenArray = computed(() => {
    return Object.keys(loginTokens.value).map((domain) => {
        return { ...loginTokens.value[domain], domain }
    })
})

const hasError = computed(() => {
    return !!error.value
})

function selectToken(loginToken: LoginTokenFull) {
    const { domain, token } = loginToken
    const url = buildMagicLink({ domain, token })
    router.replace({ name: 'magiclogin', query: { url } })
}

function onTenantChange(text: string) {
    tenant.value = text.toLowerCase()
}

async function onSupportLogin() {
    if (loading.value) {
        return
    }
    loading.value = true
    const toastTime = showToast(
        emitter,
        ToastIcon.Waiting,
        ToastColor.Shoutout,
        'Searching...'
    )
    let response: any = null
    try {
        response = await loginSupportAndRedirectHome(
            tenant.value,
            adminEmail.value,
            adminToken.value
        )
    } finally {
        loading.value = false
        hideToast(emitter, toastTime)
    }

    if (response) {
        if (response.raw.status === 404) {
            error.value = 'Please enter a valid tenant name'
        } else {
            error.value = 'Authentication failed, please contact support'
        }
    }
}

onUnmounted(() => {
    store.dispatch('clearLoginTokens')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BackHeader),
    _createElementVNode("div", _hoisted_2, [
      (adminToken.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(InputSingleLine, {
                  class: "tenant-search",
                  autocomplete: "off",
                  autocapitalize: "off",
                  variant: "glass",
                  type: "search",
                  value: tenant.value,
                  label: error.value ? error.value : 'Enter the Tenant Name',
                  spellcheck: false,
                  error: hasError.value,
                  disabled: loading.value,
                  onChange: onTenantChange,
                  onEnterpressed: onSupportLogin
                }, null, 8, ["value", "label", "error", "disabled"]),
                _createVNode(_unref(FontAwesomeIcon), {
                  class: _normalizeClass(["do-search", { error: error.value }]),
                  icon: 
                                loading.value ? _unref(faHourglassHalf) : _unref(faArrowCircleRight)
                            ,
                  onClick: onSupportLogin
                }, null, 8, ["class", "icon"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loginTokenArray.value, (loginToken) => {
        return (_openBlock(), _createElementBlock("div", {
          key: loginToken.token,
          class: "account-container",
          onClick: ($event: any) => (selectToken(loginToken))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Typography, {
              class: "account-row",
              variant: "overline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(loginToken.company || loginToken.domain), 1)
              ], undefined, true),
              _: 2
            }, 1024)
          ])
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}
}

})